import { Outlet } from 'react-router-dom'
import { useTorch } from '@/hooks'
import { RouteSound } from '@/features/audio'
import { Footer } from '../Footer'
import { NavRail } from '../NavRail'
import { PageTransition } from '../PageTransition'
import { ScrollToTop } from '../ScrollToTop'
import styles from './RootLayout.module.css'

/**
 * The chrome every page shares: the lateral navigation rail, the routed page
 * and the footer.
 *
 * `RouteSound` renders nothing — it lives here because it needs the router's
 * location, which the sound provider above the router cannot see.
 *
 * The closing CTA and the social row are not here — the original varies them
 * per page, so each page composes its own outro.
 */
export const RootLayout = () => {
  // One delegated pointer listener lights every card and button on the site.
  useTorch()

  return (
  <div className={styles.shell}>
    <ScrollToTop />
    <RouteSound />
    <NavRail />
    <main id="main" className={styles.main}>
      <PageTransition>
        <Outlet />
      </PageTransition>
    </main>
    <Footer />
  </div>
  )
}
